/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  /**
   * Подсказки для формы оформления претензии
   */
  app.ClaimFormTipsView = app.View.extend({
    additionalOptions: ['url', 'getParams', 'getTipValue', 'templateName'],
    events: {
      'keyup .suggested': 'handleUserInput',
      'focus .suggested': 'handleUserInput',
      'blur .suggested': 'remove',
      /* mousedown вместо click, так как необходимо предотвращать расфокус поля
         при выборе подсказки из списка */
      'mousedown .dropdown-item': 'handleMouseDown',
    },
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate(this.templateName);
    },
    /**
    * Обработка фокуса и ввода в поле
    * @param {Event} event Событие нажатия клавиши клавиатуры
    */
    handleUserInput: _.debounce(function (event) {
      this.load($(event.target).val().trim());
    }, 200),
    /**
     * Автоподстановка подсказок
     */
    autocomplete: function () {
      this.autocompleted = true;
      this.$('input').focus();
    },
    /**
     * Загрузка списка подсказок
     * @param {string} query Запрос
     */
    load: function (query) {
      var requestParams = this.getParams ? this.getParams() : {};
      if (query) {
        requestParams.query = query;
      }
      this.fetchTips({
        url: this.url,
        data: requestParams,
        success: this.handleLoad.bind(this),
        error: this.remove.bind(this),
      });
    },
    /**
     * Функция для запроса поисковых подсказок
     * @param {Object} params Параметры запроса
     */
    fetchTips: function (params) {
      $.ajax({
        url: app.entryScriptName + params.url,
        type: 'GET',
        data: params.data,
        headers: {
          'Simaland-Client-Timezone': String(new Date().getTimezoneOffset()),
        },
        success: params.success,
        error: params.error
      });
    },
    /**
     * Обработка успешного получения данных подсказок
     * @param {Array} data Данные списка подсказок
     */
    handleLoad: function (data) {
      if (
        Array.isArray(data)
        && data.length === 1
        && this.getTipValue
        && this.autocompleted
      ) {
        var value = this.getTipValue(data[0]);
        if (value) {
          this.setTipValue(value);
        }
      } else {
        this.render(data);
      }
      this.autocompleted = false;
    },
    /**
     * Вывод подсказок в разметку
     * @param {Array} data Список поисковых подсказок
     */
    render: function (data) {
      var element = $(this.template({
        data: data
      }));
      if (this.$('.dropdown').length) {
        this.$('.dropdown').replaceWith(element);
      } else {
        this.$('input').after(element);
      }
    },
    /**
     * Удаление поисковых подсказок из разметки
     */
    remove: function () {
      this.$('.dropdown').remove();
    },
    /**
     * Обработка события нажатия мышью на подсказку
     * @param { Event } event Событие
     */
    handleMouseDown: function (event) {
      // Необходимо для предотвращения события blur на поле ввода номера заказа
      event.preventDefault();
      var value = $(event.currentTarget).data('value');
      if (value) {
        this.setTipValue(value);
      }
    },
    /**
     * Установка значения выбранной подсказки в поле ввода
     * @param {string} value Значение, которое будет установлено в поле
     */
    setTipValue: function (value) {
      this.$('input').val(value).blur();
      this.remove();
    },
});

})(jQuery);

}.call(window));